<template>
  <div
    id="app"
    :style="$route.meta.keep === 3 ? ('height:' + deviceHeight + 'px') : 'height:100vh'"
  >
    <div v-if="$route.meta.keep === 2" style="height: 100%;">
      <!-- 改造 -->
      <el-container style="height: 100%;">
        <el-aside :class="$store.getters.isCollapse ? 'aside_f' : 'aside_t'">
          <headerNav></headerNav>
        </el-aside>
        <el-container>
          <el-header>
            <top-header></top-header>
          </el-header>
          <el-main>
            <div id="maincontent">
              <router-view></router-view>
            </div>
          </el-main>
          <el-footer>
            <icp></icp>
          </el-footer>
        </el-container>
      </el-container>
    </div>
    <router-view v-if="$route.meta.keep === 1"></router-view>
    <!-- 手机端 -->
    <div v-if="$route.meta.keep === 3" style="height: 100%;">
      <el-container style="height: 100%;">
        <el-header height="50px">
          <mobile-header></mobile-header>
        </el-header>
        <el-main style="padding: 50px 0px 0px 0px;padding-top: 50px!important">
          <div id="mobilecontent">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </div>

    <div class="NoPermission" v-if="showNoPermission">
      <div class="top_center">
        <div>
          <div class="nologins">
            <div class="nologins_title">
              <div class="nologins_title_icon"></div>
              <div class="nologins_title_text center">
                尚未开通权限，前往购买套餐。
                <div class="flex mt20 mb20 alcen">
                  <p class="yes center cursor ba6e coff ru5 sz14" @click="gopage">是</p>
                  <p class="no center cursor sz14 ru5 co6e" @click="retrns">否</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="NoPermission" v-if="showNoIndustry">
      <div class="top_center">
        <div>
          <div class="nologins">
            <div class="nologins_title">
              <div class="nologins_title_icon"></div>
              <div class="nologins_title_text center">
                尚未配置行业品牌，请先前往配置。
                <div class="flex mt20 mb20 alcen">
                  <p class="yes center cursor ba6e coff ru5 sz14" @click="goInfo">是</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="kfshow" v-if="showAiSpark">
      <div class="nologins_title">
        <div class="nologins_title_icon">
          <i class="el-icon-close cursor" @click="showAiSpark = false"></i>
        </div>
        <div class="nologins_title_img">
          <img src="@/assets/img/home/kf2.png" alt />
        </div>
        <div class="nologins_title_text center">请联系客服开通</div>
      </div>
    </div>

    <div class="deleteShow" v-if="deleteAccount">
      <div class="nologins_title">
        <div class="nologins_title_icon">
          <i class="el-icon-close cursor" @click="deleteAccount = false"></i>
        </div>
        <div class="nologins_title_text center">
          <div class="infoli_two">
            <el-form :inline="true" :model="deleteForm" ref="form3" :rules="rules2">
              <div class="infoli_title font_bo">删除个人账户</div>
              <div class="magbutt magbutt">
                <div class="magrtop">
                  <div class="magrtop_input">
                    <el-form-item label prop="password" style="width: 100%">
                      <el-input
                        type="password"
                        style="height:45px;line-height:45px"
                        prefix-icon="el-icon-lock"
                        placeholder="请输入您的确认密码"
                        v-model="deleteForm.password"
                        show-password
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="agreement" style="margin-top: 30px;">
                  <el-checkbox v-model="isread">我同意遵守与FOSHO平台的相关协议,并自愿删除个人账户。</el-checkbox>
                </div>
              </div>
              <div style="margin-top:20px">
                <div class="login center cursor" @click="deletetoAccount('form3')">删除</div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <copilot v-if="noLogin"></copilot>
  </div>
</template>
<script>
import MobileHeader from "./components/MobileHeader.vue";
import Header from "./components/Header.vue";
import TopHeader from "./components/topHeader.vue";
import Icp from "@/views/icp/icp.vue";
import copilot from "@/components/copilot.vue";
import util from "@/utils/util";
import { DELETEACCOUNT } from "@/api/personal";
import { QUERY, EXIT, PERMITS, RECORDS, CHANGEPASSWORD } from "@/api/personal";
import EDC from "@/utils/dec";
export default {
  components: {
    headerNav: Header,
    Icp,
    TopHeader,
    MobileHeader,
    copilot
  },
  data() {
    return {
      showNoPermission: false, //是否有权限
      showAiSpark: false,
      showNoIndustry: false,
      deleteAccount: false, //删除账号
      noLogin: false,
      deviceHeight: null,
      deleteForm: {
        password: ""
      },
      rules2: {
        password: [
          { required: true, message: "请输入正确的密码", trigger: "blur" }
        ]
      },
      isread: false
    };
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.noLogin = localStorage.getItem("token");
      },
      immediate: true
    }
  },
  created() {
    this.deviceHeight = this.getWindowHeight();
  },
  mounted() {
    let config = this.$versionConfig;
    if (localStorage.getItem("v_num")) {
      if (config.v_num > localStorage.getItem("v_num")) {
        localStorage.setItem("v_num", config.v_num);
        location.reload();
      }
    } else {
      localStorage.setItem("v_num", config.v_num);
      location.reload();
    }

    this.$bus.$on("showNopermiss", data => {
      this.showNoPermission = data;
    });
    this.$bus.$on("showAiSpark", data => {
      this.showAiSpark = data;
    });
    this.$bus.$on("deleteAccount", data => {
      this.deleteAccount = data;
    });
    this.$bus.$on("showNoIndustry", data => {
      this.showNoIndustry = data;
    });
  },
  methods: {
    gopage() {
      this.$router.push("./package");
      this.showNoPermission = false;
    },
    goInfo() {
      this.$router.push("./info");
      this.showNoIndustry = false;
    },
    retrns() {
      this.showNoPermission = false;
    },

    

    //获取设备可视高度
    getWindowHeight() {
      let windowHeight = window.innerHeight;
      if (typeof windowWidth !== "number") {
        if (document.compatMode === "CSS1Compat") {
          windowHeight = document.documentElement.clientHeight;
        } else {
          windowHeight = window.body.clientHeight;
        }
      }
      return windowHeight;
    },

    // 删除账号
    deletetoAccount() {
      let rules = new Promise((resolve, reject) => {
        this.$refs["form3"].validate(valid => {
          if (valid) {
            if (this.isread) {
              resolve();
            }
          }
        });
      });
      Promise.all([rules]).then(() => {
        this.deletemyAccount();
      });
    },
    deletemyAccount() {
      DELETEACCOUNT({ password: this.deleteForm.password }).then(res => {
        if (res.data.code === "error") {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        } else {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          EXIT().then(res => {
            if (res.data.code == "error") {
              this.$message.error(res.data.msg);
            } else {
              this.$bus.$emit("noLogin", false);
              localStorage.clear();
              this.$router.push("/");
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
#app {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  // font-family: "OPPOSans-R";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #000;
  background: #fafafd;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #000;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#mobilecontent {
  height: 100%;
  overflow: scroll;
}

div {
  box-sizing: border-box;
}

.el-aside {
  width: 250px !important;
}

.aside_f {
  width: 65px !important;
}

.aside_t {
  width: 250px !important;
  min-width: 135px !important;
}

/deep/.el-header {
  width: 100% !important;
  height: 55px!important;
  padding: 0 !important;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  box-shadow: 0 0.0625rem 0 0.0625rem #e7e8f2;
  background: #ffffff;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 998;
}

.el-main {
  padding-top: 75px !important;
}

.NoPermission {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.6);

  .nologins {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    .nologins_title {
      width: 400px;
      // height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      margin-left: -200px;
      background: #fff;
      border-radius: 15px;
      padding: 20px;
    }

    .nologins_title_icon {
      width: 100%;
      text-align: right;
      font-size: 26px;
      padding-right: 10px;

      i {
        color: #000;
      }
    }

    .nologins_title_img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      margin-top: 40px;

      img {
        width: 200px;
        height: 200px;
        display: inline-block;
        margin: 0 auto;
      }
    }

    .nologins_title_text {
      width: 100%;
      margin-top: 20px;
      font-size: 22px;

      div {
        justify-content: space-around;
      }

      .yes {
        width: 100px;
        height: 40px;
        line-height: 40px;
      }

      .no {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #be3c6e;
      }
    }
  }
}

.kfshow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 999;

  .nologins_title {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #fff;
    border-radius: 15px;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 100%;
    margin-top: 50px;
    font-size: 22px;
  }
}

.deleteShow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5, #000);
  z-index: 999;

  .nologins_title {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0%;
    background: #fff;
    padding: 20px;
  }

  .nologins_title_icon {
    width: 100%;
    text-align: right;
    font-size: 26px;
    padding-right: 10px;

    i {
      color: #000;
    }
  }

  .nologins_title_img {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-top: 40px;

    img {
      width: 200px;
      height: 200px;
      display: inline-block;
      margin: 0 auto;
    }
  }

  .nologins_title_text {
    width: 450px;
    margin: 50px auto;
    font-size: 22px;

    .infoli_two {
      // height: 100%;
      min-height: 540px;
      border-radius: 5px;
      background: #fff;
      padding: 100px 0px 0px 0px !important;
      box-sizing: border-box;

      .infoli_title {
        width: 100%;
        font-size: 22px;
        text-align: center;
        margin-bottom: 20px;
      }

      .magrtop_input {
        margin: 9px 0px 50px 0px;
        height: 36px;
      }

      .login {
        width: 100%;
        height: 55px;
        line-height: 55px;
        border-radius: 18px;
        font-size: 18px;
        background: #c44f7c;
        color: #fff;
        margin: 0 auto;
      }
    }

    /deep/.el-checkbox__inner {
      position: absolute;
      top: 7px;
      right: 0;
    }

    .password {
      span {
        display: inline-block;
        width: 50%;
      }
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background-color: #fff;
}
</style>
